module.exports = __webpack_public_path__ + "img/act_11_step4.1d11713d.png";